import { PostMeta } from '@/model/data-object/PostMeta'
import { IVoteStats } from '@/model/interface/IVoteStats'
import { VoteStats } from '@/model/data-object/VoteStats'
import { PostViolation } from '@/model/data-object/PostViolation'
import { PostTopic } from '@/model/data-object/PostTopic'
import { UserBlog } from '@/model/data-object/UserBlog'
import { PubUser } from '@/model/data-object/PubUser'

export enum SettingsStatus {
  ACTIVE = 'active',
  WAITING = 'waiting',
  HIDDEN = 'hidden',
  DELETED = 'deleted',
  HIDDEN_DELETED = 'hidden_deleted',
  GDPR_DELETED = 'gdpr_deleted',
}

export class Post {
  id = 0
  content = ''
  contentRaw = ''
  topic: PostTopic = new PostTopic()
  stats: IVoteStats = new VoteStats()
  parent: number | null = null
  path = ''
  pathDesc = ''
  ipAddress = ''
  modified = false
  editedAt: Date = new Date()
  status = SettingsStatus.ACTIVE
  createdAt: Date = new Date()
  author: PubUser = new PubUser()
  blog: UserBlog = new UserBlog()
  postMeta: PostMeta = new PostMeta()
  violations: Array<PostViolation> = []

  isHidden() {
    return [SettingsStatus.HIDDEN, SettingsStatus.GDPR_DELETED].includes(
      this.status
    )
  }
}
